import { render, staticRenderFns } from "./PatientPage.vue?vue&type=template&id=0306f85c&scoped=true&"
import script from "./PatientPage.vue?vue&type=script&lang=js&"
export * from "./PatientPage.vue?vue&type=script&lang=js&"
import style0 from "./PatientPage.vue?vue&type=style&index=0&id=0306f85c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0306f85c",
  null
  
)

export default component.exports